class Step {
  name;
  description;
  component;
  isValid = (data) => {
    return true
  };
  getErrors = () => {
    return false;
  }
  shouldSkip = (data) => false;

  constructor(options) {
    Object.assign(this, options);
  }

  hasChildren = () => {
    return false;
  }
}

export class SequenceStep {
  name;
  description;
  steps;
  component = null;

  constructor(name, description, steps, component = null) {
    if (steps.length === 0) throw new Error("Should be array!!");
    this.name = name;
    this.description = description;
    this.steps = steps;
    this.component = component;
  }

  shouldSkip = (data) => false;

  getChildByPath = (path, data) => { //gets what is active for this step, first item if nothing is passed
    console.log('Sequence: getChildByPath', path, this.steps);
    return this.steps.find(step => {
      return (!path || !path.includes(step.name)) && !step.shouldSkip(data);
    });
  }

  isValid(data) {
    return true;
  }

  getErrors(data) {
  }

  hasChildren = () => {
    return true;
  }
}

export class DecisionStep { // todo common interfaec
  name;
  description;
  component = null; //Custom selection
  options; //list of decision options

  constructor(name, description, options, component = null) {
    this.name = name;
    this.description = description;
    this.options = options;
    this.component = component;
  }

  shouldSkip = (data) => false;

  isValid = (data) => {
    return data && data[this.name] !== undefined;
  }

  getErrors = () => {
    return "You need to fill out this field";
  }

  getStepByName = (name) => {
    console.log('getStepByName', name, this.options);
    return this.options.find(o => o.name === name);
  };

  getSelectedPath = (data) => {
    const name = data[this.name];
    return this.getStepByName(name);
  }

  getChildByPath = (path) => { //gets what is active for this step, itself if nothing is passed
    if (!path) {
      return this;
    } else if (path.length === 1) {
      return this.getStepByName(path[0])
    } else {
      return null;
    }
  }

  hasChildren = () => {
    return true;
  };
}

export class Process {
  step; // Decision Steps or Sequence steps
  data = {}; //model?
  onChange = () => {

  }; //method to update data

  constructor(step, data, onChange) {
    this.step = step;
    this.data = data;
    this.onChange = onChange;
  }

  getPathForStep = (step, data) => {
    const passedSteps = data.passedSteps || {};
    return passedSteps[step.name];
  }

  getCurrentChild = (data) => {
    const step = this.getCurrentStep(data);
    const path = this.getPathForStep(step, data);
    const child = step.getChildByPath(path, data);

    if (child && child.hasChildren() && this.isCompletedStep(child, data)) {
      return step.getChildByPath([...(path || []), child.name], data);
    } else {
      return child;
    }
  }

  getPathForCompletion = (data) => {
    const child = this.getCurrentChild(data);
    if (child instanceof DecisionStep) {
      const check = child.getSelectedPath(data);
      console.log('check', check, child);
      return check;
    } else {
      return child;
    }
  }

  isCompletedStep = (currentStep, data) => {
    const path = this.getPathForStep(currentStep, data);
    if (currentStep instanceof SequenceStep) {
      const itemsCount = path ? path.length : 0;
      return currentStep.steps.length === itemsCount;
    } else if (currentStep instanceof DecisionStep) {
      const child = currentStep.getChildByPath(path, data);
      return child.name !== currentStep.name && this.isCompletedStep(child, data); //decision returns itself if nothing selected
    } else {
      throw new Error(`Component not found for step ${currentStep.name}`);
    }
  }

  getCurrentStep = (data) => {
    let currentStep = this.step;

    while (true) {
      const path = this.getPathForStep(currentStep, data);

      if (!path) {
        return currentStep;
      } else {
        const nextStep = currentStep.getChildByPath(path, data);
        if (nextStep && nextStep.hasChildren() && !this.isCompletedStep(nextStep, data)) {
          currentStep = nextStep;
        } else {
          return currentStep;
        }
      }
    }
  }

  getMaxStepNestedCount = (step) => {
    if (step instanceof SequenceStep) {
      return step.steps.reduce((total, step) => (this.getMaxStepNestedCount(step) + total), 0);
    } else if (step instanceof DecisionStep) {
      const  stepOptions = step.options.map(option => (this.getMaxStepNestedCount(option)));
      return Math.max(...stepOptions);
    } else {
      return 1;
    }
  };

  getMaximumStepsCount = (data) => {
    // should count passed + left from last component + current component
    const currentStep = this.getCurrentStep(data);
    const maxStepsForCurrenStep = this.getMaxStepNestedCount(currentStep);
    const passedStepsCount = this.getPassedStepsCount(data);
    const passedStepsInCurrentStep = ((data.passedSteps || {})[currentStep.name] || []).length;
    console.log('getMaximumStepsCount', currentStep, maxStepsForCurrenStep, passedStepsCount, passedStepsInCurrentStep);
    // return this.getMaxStepNestedCount(currentStep) + 1;// this.getPassedStepsCount(data); would not work for
    return maxStepsForCurrenStep + passedStepsCount - passedStepsInCurrentStep;// this.getPassedStepsCount(data); would not work for
  };
  getPassedStepsCount = (data) => {
    return data.passedSteps ? data.passedSteps.wholePass.length : 0;
  };

  isLastStep = (data) => {
    const step = this.getCurrentStep(data);
    const path = this.getPathForStep(step, data);
    const child = step.getChildByPath(path, data);

    console.log('step', step, path, child, step.name === this.step.name, step.getChildByPath([...(path || []), child.name], data));
    // not decision step and not empty next item
    //need to fix for nested component to work `step.name === this.step.name &&` need to understand path in tree!
    return step.name !== child.name && !step.getChildByPath([...(path || []), child.name], data);
  }

}

export default Step;